module.exports = __webpack_public_path__ + "media/images/athletes/23-4d4ca1ebf28de4863685b75d921cd059.png";